(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var parseNumber = sbbNamespace.parseNumber;
  var paperSizes = sbbNamespace.paperSizes;
  var softwarePresets = sbbNamespace.softwarePresets;
  var tagTypes = sbbNamespace.tagTypes;
  var shapeTypes = sbbNamespace.shapeTypes;
  var aprilTagByValue = sbbNamespace.aprilTagByValue;
  var circularByValue = sbbNamespace.circularByValue;
  var fontOptions = sbbNamespace.fontOptions;
  var commandUnitOptions = sbbNamespace.commandUnitOptions;
  var defaultNoiseColorA = sbbNamespace.defaultNoiseColorA;
  var defaultNoiseColorB = sbbNamespace.defaultNoiseColorB;
  var logoDataUrl = sbbNamespace.logoDataUrl;

  if (!ScaleBarBuilder || !parseNumber || !paperSizes || !softwarePresets || !tagTypes || !shapeTypes || !aprilTagByValue || !circularByValue || !fontOptions || !commandUnitOptions) {
    return;
  }

  var PAPER_SIZES = paperSizes;
  var SOFTWARE_PRESETS = softwarePresets;
  var TAG_TYPES = tagTypes;
  var SHAPE_TYPES = shapeTypes;
  var FONT_OPTIONS = fontOptions;
  var COMMAND_UNIT_OPTIONS = commandUnitOptions;
  var DEFAULT_NOISE_COLOR_A = defaultNoiseColorA;
  var DEFAULT_NOISE_COLOR_B = defaultNoiseColorB;


  ScaleBarBuilder.prototype.bindElements = function () {
    var q = this.root.querySelector.bind(this.root);

    this.controls = {
      shell: q('.sbb-shell'),
      topShelf: q('.sbb-top-shelf'),
      topBrand: q('.sbb-top-brand'),
      brandHero: q('[data-sbb="brand-hero"]'),
      brandText: q('[data-sbb="brand-text"]'),
      brandLogo: q('[data-sbb="brand-logo"]'),
      mainShelf: q('[data-sbb="main-shelf"]'),
      documentPanel: q('[data-sbb-panel="document"]'),
      mobileTabs: q('[data-sbb="mobile-tabs"]'),
      tabDocument: q('[data-sbb="tab-document"]'),
      tabCanvas: q('[data-sbb="tab-canvas"]'),
      tabEdit: q('[data-sbb="tab-edit"]'),
      layout: q('.sbb-layout'),
      sidebar: q('.sbb-controls'),
      advancedControls: q('[data-sbb="advanced-controls"]'),
      settingsMenu: q('.sbb-doc-settings-menu'),
      leftTopSlot: q('[data-sbb="left-top-slot"]'),
      canvasWrap: q('.sbb-canvas-wrap'),
      previewToolbar: q('.sbb-preview-toolbar'),
      templateSelect: q('[data-sbb="template-select"]'),
      loadTemplate: q('[data-sbb="load-template"]'),
      resetSession: q('[data-sbb="reset-session"]'),
      shareSession: q('[data-sbb="share-session"]'),
      startGuide: q('[data-sbb="start-guide"]'),
      startGuideInDepth: q('[data-sbb="start-guide-in-depth"]'),
      openAdvanced: q('[data-sbb="open-advanced"]'),
      softwarePreset: q('[data-sbb="software-preset"]'),
      tagType: q('[data-sbb="tag-type"]'),
      tagFamily: q('[data-sbb="tag-family"]'),
      paperSize: q('[data-sbb="paper-size"]'),
      paperOrientation: q('[data-sbb="paper-orientation"]'),
      unitSystem: q('[data-sbb="unit-system"]'),
      tagCount: q('[data-sbb="tag-count"]'),
      tagSize: q('[data-sbb="tag-size"]'),
      spacing: q('[data-sbb="spacing"]'),
      corner: q('[data-sbb="corner"]'),
      cornerMargin: q('[data-sbb="corner-margin"]'),
      cutMargin: q('[data-sbb="cut-margin"]'),
      printMargin: q('[data-sbb="print-margin"]'),
      layoutMode: q('[data-sbb="layout-mode"]'),
      snapEnabled: q('[data-sbb="snap-enabled"]'),
      showPlacementGuides: q('[data-sbb="show-placement-guides"]'),
      filterAprilTagCenters: q('[data-sbb="filter-apriltag-centers"]'),
      snapGrid: q('[data-sbb="snap-grid"]'),
      snapGridDivisions: q('[data-sbb="snap-grid-divisions"]'),
      defaultFont: q('[data-sbb="default-font"]'),
      idList: q('[data-sbb="id-list"]'),
      idValidity: q('[data-sbb="id-validity"]'),
      stepList: q('[data-sbb="step-list"]'),
      showGrid: q('[data-sbb="show-grid"]'),
      showDistances: q('[data-sbb="show-distances"]'),
      showReferenceMeasurements: q('[data-sbb="show-reference-measurements"]'),
      checkerWidth: q('[data-sbb="checker-width"]'),
      checkerHeight: q('[data-sbb="checker-height"]'),
      gridRatio: q('[data-sbb="grid-ratio"]'),
      presetNote: q('[data-sbb="preset-note"]'),
      backgroundMode: q('[data-sbb="background-mode"]'),
      backgroundColor: q('[data-sbb="background-color"]'),
      backgroundFile: q('[data-sbb="background-file"]'),
      backgroundOpacity: q('[data-sbb="background-opacity"]'),
      backgroundNoiseEnabled: q('[data-sbb="background-noise-enabled"]'),
      backgroundNoiseSize: q('[data-sbb="background-noise-size"]'),
      backgroundNoiseContrast: q('[data-sbb="background-noise-contrast"]'),
      backgroundNoiseColorA: q('[data-sbb="background-noise-color-a"]'),
      backgroundNoiseColorB: q('[data-sbb="background-noise-color-b"]'),
      inspector: q('[data-sbb="inspector"]'),
      templateExportPanel: q('[data-sbb="template-export-panel"]'),
      templateExportId: q('[data-sbb="template-export-id"]'),
      templateExportName: q('[data-sbb="template-export-name"]'),
      templateExportDescription: q('[data-sbb="template-export-description"]'),
      templateCopyDetails: q('[data-sbb="template-copy-details"]'),
      templateExportOutput: q('[data-sbb="template-export-output"]'),
      showGuideAdvanced: q('[data-sbb="show-guide-advanced"]'),
      downloadDesign: q('[data-sbb="download-design"]'),
      uploadDesign: q('[data-sbb="upload-design"]'),
      importDesignFile: q('[data-sbb="import-design-file"]'),
      paperInfo: q('[data-sbb="paper-info"]'),
      warnings: q('[data-sbb="warnings"]'),
      status: q('[data-sbb="status"]'),
      exportPdf: q('[data-sbb="export-pdf"]'),
      exportPng: q('[data-sbb="export-png"]'),
      toolSelect: q('[data-sbb="tool-select"]'),
      undo: q('[data-sbb="undo"]'),
      redo: q('[data-sbb="redo"]'),
      copyEntity: q('[data-sbb="copy-entity"]'),
      pasteEntity: q('[data-sbb="paste-entity"]'),
      duplicateEntity: q('[data-sbb="duplicate-entity"]'),
      addReference: q('[data-sbb="add-reference"]'),
      addText: q('[data-sbb="add-text"]'),
      addImage: q('[data-sbb="add-image"]'),
      addTag: q('[data-sbb="add-tag"]'),
      addShapeKind: q('[data-sbb="add-shape-kind"]'),
      addShape: q('[data-sbb="add-shape"]'),
      addReferenceRight: q('[data-sbb="add-reference-right"]'),
      addTextRight: q('[data-sbb="add-text-right"]'),
      addImageRight: q('[data-sbb="add-image-right"]'),
      addTagRight: q('[data-sbb="add-tag-right"]'),
      addShapeKindRight: q('[data-sbb="add-shape-kind-right"]'),
      addShapeRight: q('[data-sbb="add-shape-right"]'),
      toggleBackgroundNoise: q('[data-sbb="toggle-background-noise"]'),
      noiseSettings: q('[data-sbb="noise-settings"]'),
      setHome: q('[data-sbb="set-home"]'),
      resetHome: q('[data-sbb="reset-home"]'),
      zoomOut: q('[data-sbb="zoom-out"]'),
      zoomReset: q('[data-sbb="zoom-reset"]'),
      zoomIn: q('[data-sbb="zoom-in"]'),
      zoomLevel: q('[data-sbb="zoom-level"]'),
      selectionShelf: q('[data-sbb="selection-shelf"]'),
      layersMenu: q('[data-sbb="layers-menu"]'),
      layersPanel: q('[data-sbb="layers-panel"]'),
      inlineTextEditor: q('[data-sbb="inline-text-editor"]'),
      downloadTagCsv: q('[data-sbb="download-tag-csv"]'),
      downloadMetashapePy: q('[data-sbb="download-metashape-py"]'),
      realityScanOutputMode: q('[data-sbb="realityscan-output-mode"]'),
      commandUnitMode: q('[data-sbb="command-unit-mode"]'),
      commandOutput: q('[data-sbb="command-output"]'),
      usedTagCsv: q('[data-sbb="used-tag-csv"]'),
      uploadIgnoreCsv: q('[data-sbb="upload-ignore-csv"]'),
      ignoreCsvFile: q('[data-sbb="ignore-csv-file"]')
    };

    this.controls.imagePickerOverlay = q('[data-sbb="image-picker-overlay"]');
    this.controls.imagePickerDismiss = q('[data-sbb="image-picker-dismiss"]');
    this.controls.imagePickerCard = q('[data-sbb="image-picker-card"]');
    this.controls.imagePickerModeUpload = q('[data-sbb="image-picker-mode-upload"]');
    this.controls.imagePickerModeUrl = q('[data-sbb="image-picker-mode-url"]');
    this.controls.imagePickerUploadPanel = q('[data-sbb="image-picker-upload-panel"]');
    this.controls.imagePickerUrlPanel = q('[data-sbb="image-picker-url-panel"]');
    this.controls.imagePickerFile = q('[data-sbb="image-picker-file"]');
    this.controls.imagePickerUrlInput = q('[data-sbb="image-picker-url-input"]');
    this.controls.imagePickerUrlPreview = q('[data-sbb="image-picker-url-preview"]');
    this.controls.imagePickerPreview = q('[data-sbb="image-picker-preview"]');
    this.controls.imagePickerPreviewEmpty = q('[data-sbb="image-picker-preview-empty"]');
    this.controls.imagePickerStatus = q('[data-sbb="image-picker-status"]');
    this.controls.imagePickerCancel = q('[data-sbb="image-picker-cancel"]');
    this.controls.imagePickerInsert = q('[data-sbb="image-picker-insert"]');

    this.controls.exportOverlay = q('[data-sbb="export-overlay"]');
    this.controls.exportDismiss = q('[data-sbb="export-dismiss"]');
    this.controls.exportCard = q('[data-sbb="export-card"]');
    this.controls.exportPreviewWrap = q('.sbb-export-preview-wrap');
    this.controls.exportPreviewCanvas = q('[data-sbb="export-preview-canvas"]');
    this.controls.exportPdfDpi = q('[data-sbb="export-pdf-dpi"]');
    this.controls.exportPdfDpiPreset = q('[data-sbb="export-pdf-dpi-preset"]');
    this.controls.exportPdfMode = q('[data-sbb="export-pdf-mode"]');
    this.controls.exportFormat = q('[data-sbb="export-format"]');
    this.controls.exportPdfEffectiveDpi = q('[data-sbb="export-pdf-effective-dpi"]');
    this.controls.exportPreviewStatus = q('[data-sbb="export-preview-status"]');
    this.controls.exportCommandOutput = q('[data-sbb="export-command-output"]');
    this.controls.exportCancel = q('[data-sbb="export-cancel"]');
    this.controls.exportConfirm = q('[data-sbb="export-confirm"]');

    this.controls.guideOverlay = q('[data-sbb="guide-overlay"]');
    this.controls.guideSpotlight = q('[data-sbb="guide-spotlight"]');
    this.controls.guideCard = q('[data-sbb="guide-card"]');
    this.controls.guideDismiss = q('[data-sbb="guide-dismiss"]');
    this.controls.guideStepIndex = q('[data-sbb="guide-step-index"]');
    this.controls.guideTitle = q('[data-sbb="guide-title"]');
    this.controls.guideBody = q('[data-sbb="guide-body"]');
    this.controls.guideBack = q('[data-sbb="guide-back"]');
    this.controls.guideNext = q('[data-sbb="guide-next"]');
    this.controls.guideSkip = q('[data-sbb="guide-skip"]');

    this.canvas = q('[data-sbb="canvas"]');
    this.ctx = this.canvas.getContext('2d');

    this.unitLabels = {
      tagSize: q('[data-sbb-unit-label="tag-size"]'),
      spacing: q('[data-sbb-unit-label="spacing"]'),
      cornerMargin: q('[data-sbb-unit-label="corner-margin"]'),
      cutMargin: q('[data-sbb-unit-label="cut-margin"]'),
      printMargin: q('[data-sbb-unit-label="print-margin"]'),
      snapGrid: q('[data-sbb-unit-label="snap-grid"]'),
      checkerWidth: q('[data-sbb-unit-label="checker-width"]'),
      checkerHeight: q('[data-sbb-unit-label="checker-height"]'),
      backgroundNoiseSize: q('[data-sbb-unit-label="background-noise-size"]')
    };
  };


  ScaleBarBuilder.prototype.initTopShelfControls = function () {
    this.controls.mainShelf = this.controls.mainShelf || this.root.querySelector('[data-sbb="main-shelf"]');
    this.controls.settingsMenu = this.controls.settingsMenu || this.controls.advancedControls;
    if (this.controls.brandLogo && logoDataUrl) {
      this.controls.brandLogo.src = logoDataUrl;
    }
    this.applyMobileTabState('canvas');
  };


  ScaleBarBuilder.prototype.populateSelects = function () {
    var i;

    this.controls.softwarePreset.innerHTML = '';
    Object.keys(SOFTWARE_PRESETS).forEach(function (presetKey) {
      var presetOpt = document.createElement('option');
      presetOpt.value = presetKey;
      presetOpt.textContent = SOFTWARE_PRESETS[presetKey].label;
      this.controls.softwarePreset.appendChild(presetOpt);
    }, this);

    if (this.controls.tagType) {
      this.controls.tagType.innerHTML = '';
      for (i = 0; i < TAG_TYPES.length; i += 1) {
        var typeOpt = document.createElement('option');
        typeOpt.value = TAG_TYPES[i].value;
        typeOpt.textContent = TAG_TYPES[i].label;
        this.controls.tagType.appendChild(typeOpt);
      }
    }

    this.controls.paperSize.innerHTML = '';
    Object.keys(PAPER_SIZES).forEach(function (key) {
      var opt = document.createElement('option');
      opt.value = key;
      opt.textContent = PAPER_SIZES[key].label;
      this.controls.paperSize.appendChild(opt);
    }, this);

    this.controls.defaultFont.innerHTML = '';
    FONT_OPTIONS.forEach(function (fontName) {
      var fontOpt = document.createElement('option');
      fontOpt.value = fontName;
      fontOpt.textContent = fontName;
      this.controls.defaultFont.appendChild(fontOpt);
    }, this);

    if (this.controls.commandUnitMode) {
      this.controls.commandUnitMode.innerHTML = '';
      for (i = 0; i < COMMAND_UNIT_OPTIONS.length; i += 1) {
        var commandUnitOpt = document.createElement('option');
        commandUnitOpt.value = COMMAND_UNIT_OPTIONS[i].value;
        commandUnitOpt.textContent = COMMAND_UNIT_OPTIONS[i].label.replace('1 unit = ', '');
        this.controls.commandUnitMode.appendChild(commandUnitOpt);
      }
    }

    if (this.controls.addShapeKind) {
      this.controls.addShapeKind.innerHTML = '';
      for (i = 0; i < SHAPE_TYPES.length; i += 1) {
        var shapeOpt = document.createElement('option');
        shapeOpt.value = SHAPE_TYPES[i].value;
        shapeOpt.textContent = SHAPE_TYPES[i].label;
        this.controls.addShapeKind.appendChild(shapeOpt);
      }
      this.controls.addShapeKind.value = 'rectangle';
    }
    if (this.controls.addShapeKindRight) {
      this.controls.addShapeKindRight.innerHTML = this.controls.addShapeKind ? this.controls.addShapeKind.innerHTML : '';
      this.controls.addShapeKindRight.value = this.controls.addShapeKind ? this.controls.addShapeKind.value : 'rectangle';
    }
  };


  ScaleBarBuilder.prototype.applyMobileTabState = function (tabName) {
    if (!this.controls || !this.controls.shell) {
      return;
    }
    var tab = tabName || this.activeMobileTab || 'canvas';
    this.activeMobileTab = tab;
    this.controls.shell.setAttribute('data-sbb-mobile-tab', tab);
    if (this.controls.tabDocument) {
      this.controls.tabDocument.classList.toggle('active', tab === 'document');
    }
    if (this.controls.tabCanvas) {
      this.controls.tabCanvas.classList.toggle('active', tab === 'canvas');
    }
    if (this.controls.tabEdit) {
      this.controls.tabEdit.classList.toggle('active', tab === 'edit');
    }
  };


  ScaleBarBuilder.prototype.syncControlsFromState = function () {
    this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
    this.controls.softwarePreset.value = this.state.softwarePreset;
    if (this.controls.tagType) {
      this.controls.tagType.value = this.state.tagType;
    }
    this.controls.tagFamily.value = this.state.tagFamily;
    this.controls.paperSize.value = this.state.paperSize;
    this.controls.paperOrientation.value = this.state.paperOrientation;
    this.controls.unitSystem.value = this.state.unitSystem;
    this.controls.tagCount.value = this.state.tagCount;
    this.controls.tagSize.value = this.formatUiNumber(this.mmToUi(this.state.tagSizeMm), this.state.unitSystem === 'imperial' ? 3 : 1);
    this.controls.spacing.value = this.formatUiNumber(this.cmToUi(this.state.spacingCm), this.state.unitSystem === 'imperial' ? 3 : 2);
    this.controls.corner.value = this.state.corner;
    this.controls.cornerMargin.value = this.formatUiNumber(this.mmToUi(this.state.cornerMarginMm), this.state.unitSystem === 'imperial' ? 3 : 1);
    this.controls.cutMargin.value = this.formatUiNumber(this.cmToUi(this.state.cutMarginCm), this.state.unitSystem === 'imperial' ? 3 : 2);
    this.controls.printMargin.value = this.formatUiNumber(this.mmToUi(this.state.printMarginMm), this.state.unitSystem === 'imperial' ? 3 : 1);
    this.controls.showGrid.checked = this.state.showGrid;
    this.controls.showDistances.checked = this.state.showDistances;
    this.controls.showReferenceMeasurements.checked = !!this.state.showReferenceMeasurements;
    this.controls.snapEnabled.checked = this.state.snapEnabled;
    this.controls.showPlacementGuides.checked = this.state.showPlacementGuides;
    if (this.controls.filterAprilTagCenters) {
      this.controls.filterAprilTagCenters.checked = this.state.filterAprilTagCenters !== false;
      this.controls.filterAprilTagCenters.disabled = this.state.tagType !== 'apriltag';
    }
    this.controls.snapGrid.value = this.formatUiNumber(this.mmToUi(this.state.snapGridMm), this.state.unitSystem === 'imperial' ? 3 : 1);
    this.controls.snapGridDivisions.value = String(this.normalizeSnapGridDivisions(this.state.snapGridDivisions));
    this.controls.defaultFont.value = this.state.defaultFontFamily;
    this.controls.checkerWidth.value = this.formatUiNumber(this.cmToUi(this.state.checkerWidthCm), this.state.unitSystem === 'imperial' ? 3 : 2);
    this.controls.checkerHeight.value = this.formatUiNumber(this.mmToUi(this.state.checkerHeightMm), this.state.unitSystem === 'imperial' ? 3 : 1);
    if (this.controls.commandUnitMode) {
      this.controls.commandUnitMode.value = this.sanitizeCommandUnitMode(this.state.commandUnitMode);
    }
    if (this.controls.addShapeKindRight && this.controls.addShapeKind) {
      this.controls.addShapeKindRight.value = this.controls.addShapeKind.value;
    }
    this.controls.backgroundMode.value = this.state.background.mode;
    this.controls.backgroundColor.value = this.state.background.color;
    this.controls.backgroundOpacity.value = this.state.background.opacity;
    this.controls.backgroundNoiseEnabled.checked = !!(this.state.backgroundNoise && this.state.backgroundNoise.enabled);
    this.controls.backgroundNoiseSize.value = this.formatUiNumber(this.mmToUi(this.state.backgroundNoise.grainSizeMm), this.state.unitSystem === 'imperial' ? 3 : 1);
    this.controls.backgroundNoiseContrast.value = this.formatUiNumber(this.state.backgroundNoise.contrast, 2);
    this.controls.backgroundNoiseColorA.value = this.state.backgroundNoise.colorA || DEFAULT_NOISE_COLOR_A;
    this.controls.backgroundNoiseColorB.value = this.state.backgroundNoise.colorB || DEFAULT_NOISE_COLOR_B;
    if (this.controls.exportPdfDpi && this.state.exportPdfSettings) {
      this.controls.exportPdfDpi.value = String(Math.round(parseNumber(this.state.exportPdfSettings.dpi, 300)));
    }
    if (this.controls.exportPdfDpiPreset) {
      this.controls.exportPdfDpiPreset.value = '';
    }
    if (this.controls.exportPdfMode && this.state.exportPdfSettings) {
      this.controls.exportPdfMode.value = this.state.exportPdfSettings.mode === 'bitmap' ? 'bitmap' : 'hybrid-vector';
    }
    if (this.controls.exportFormat && this.state.exportPdfSettings) {
      this.controls.exportFormat.value = this.state.exportPdfSettings.format === 'jpg'
        ? 'jpg'
        : (this.state.exportPdfSettings.format === 'png' ? 'png' : 'pdf');
    }

    this.controls.layoutMode.textContent = this.state.layoutMode === 'manual' ? 'Manual (drag-enabled)' : 'Auto chain';
    this.updateUnitLabels();
    this.refreshUsedTagCsvDisplay();
    this.applySidebarCollapsedState();
  };


  ScaleBarBuilder.prototype.syncDynamicRows = function () {
    var i;
    var idBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
    var minTagId = idBounds.min;
    var maxTagId = idBounds.max;

    this.controls.stepList.innerHTML = '';
    for (i = 1; i < this.state.tagCount; i += 1) {
      var step = this.state.steps[i - 1] || { axis: 'horizontal', dir: 1 };
      var stepRow = document.createElement('div');
      stepRow.className = 'sbb-step-row';
      stepRow.innerHTML = [
        '<span>Tag ' + (i + 1) + ' offset</span>',
        '<select data-step-axis="' + (i - 1) + '">',
        '  <option value="horizontal">Horizontal</option>',
        '  <option value="vertical">Vertical</option>',
        '</select>',
        '<select data-step-dir="' + (i - 1) + '">',
        '  <option value="1">Positive</option>',
        '  <option value="-1">Negative</option>',
        '</select>'
      ].join('');
      this.controls.stepList.appendChild(stepRow);
      stepRow.querySelector('[data-step-axis]').value = step.axis;
      stepRow.querySelector('[data-step-dir]').value = String(step.dir);
    }

    this.controls.idList.innerHTML = '';
    for (i = 0; i < this.state.tagCount; i += 1) {
      var tag = this.state.tags[i];
      var idRow = document.createElement('div');
      idRow.className = 'sbb-id-row';
      idRow.innerHTML = [
        '<label>Tag ' + (i + 1) + ' ID</label>',
        '<input type="number" min="' + minTagId + '" max="' + maxTagId + '" step="1" data-tag-id="' + i + '" />'
      ].join('');
      this.controls.idList.appendChild(idRow);
      idRow.querySelector('[data-tag-id]').value = tag.id;
    }
  };


  ScaleBarBuilder.prototype.readControlsIntoState = function (sourceEventTarget) {
    this.validTagIdListCache = {};
    this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
    var oldUnit = this.state.unitSystem;
    var nextUnit = this.controls.unitSystem.value || 'metric';

    if (oldUnit !== nextUnit) {
      this.state.unitSystem = nextUnit;
      var applyUnitDefaults = false;
      if (sourceEventTarget === this.controls.unitSystem && typeof window !== 'undefined' && typeof window.confirm === 'function') {
        var unitDefaults = this.getUnitScaleDefaults(nextUnit);
        var unitLabel = nextUnit === 'imperial' ? 'Imperial' : 'Metric';
        applyUnitDefaults = window.confirm(
          'Switched to ' + unitLabel + '.\n\nApply recommended defaults for references and snap grid?\n' +
          unitDefaults.description
        );
      }
      if (applyUnitDefaults) {
        this.applyUnitScaleDefaults(nextUnit);
      } else {
        this.state.snapGridMm = this.normalizeSnapGridMmForUnit(this.state.snapGridMm, nextUnit);
        this.state.snapGridDivisions = this.normalizeSnapGridDivisions(this.state.snapGridDivisions);
      }
      this.syncControlsFromState();
      this.syncDynamicRows();
      sourceEventTarget = null;
    }

    this.state.softwarePreset = this.controls.softwarePreset.value || 'generic';
    this.state.tagFamily = this.controls.tagFamily.value || this.state.tagFamily;
    this.state.tagType = this.getTagTypeForFamily(this.state.tagFamily, this.getCurrentPreset());
    this.state.paperSize = this.controls.paperSize.value || this.state.paperSize;
    this.state.paperOrientation = this.controls.paperOrientation.value || this.state.paperOrientation;

    var previousCount = this.state.tagCount;
    this.state.tagCount = Math.max(1, Math.round(parseNumber(this.controls.tagCount.value, this.state.tagCount)));
    this.state.tagSizeMm = clamp(this.uiToMm(parseNumber(this.controls.tagSize.value, this.mmToUi(this.state.tagSizeMm))), 8, 180);
    this.state.spacingCm = clamp(this.uiToCm(parseNumber(this.controls.spacing.value, this.cmToUi(this.state.spacingCm))), 0.5, 300);
    this.state.corner = this.controls.corner.value || this.state.corner;
    this.state.cornerMarginMm = clamp(this.uiToMm(parseNumber(this.controls.cornerMargin.value, this.mmToUi(this.state.cornerMarginMm))), 0, 120);
    this.state.cutMarginCm = clamp(this.uiToCm(parseNumber(this.controls.cutMargin.value, this.cmToUi(this.state.cutMarginCm))), 0, 30);
    this.state.printMarginMm = clamp(this.uiToMm(parseNumber(this.controls.printMargin.value, this.mmToUi(this.state.printMarginMm))), 0, 40);

    this.state.showGrid = !!this.controls.showGrid.checked;
    this.state.showDistances = !!this.controls.showDistances.checked;
    this.state.showReferenceMeasurements = !!(this.controls.showReferenceMeasurements && this.controls.showReferenceMeasurements.checked);
    this.state.filterAprilTagCenters = !!(this.controls.filterAprilTagCenters && this.controls.filterAprilTagCenters.checked);
    if (!this.state.showDistances && this.state.selectedEntity && this.state.selectedEntity.type === 'distance') {
      this.state.selectedEntity = null;
    }
    this.state.snapEnabled = !!this.controls.snapEnabled.checked;
    this.state.showPlacementGuides = !!this.controls.showPlacementGuides.checked;
    this.state.snapGridMm = this.normalizeSnapGridMmForUnit(
      this.uiToMm(parseNumber(this.controls.snapGrid.value, this.mmToUi(this.state.snapGridMm))),
      this.state.unitSystem
    );
    this.state.snapGridDivisions = this.normalizeSnapGridDivisions(parseNumber(this.controls.snapGridDivisions.value, this.state.snapGridDivisions));
    this.state.defaultFontFamily = this.controls.defaultFont.value || this.state.defaultFontFamily;

    this.state.checkerWidthCm = clamp(this.uiToCm(parseNumber(this.controls.checkerWidth.value, this.cmToUi(this.state.checkerWidthCm))), 0.1, 30);
    this.state.checkerHeightMm = clamp(this.uiToMm(parseNumber(this.controls.checkerHeight.value, this.mmToUi(this.state.checkerHeightMm))), 0.5, 30);
    if (this.controls.commandUnitMode) {
      this.state.commandUnitMode = this.sanitizeCommandUnitMode(this.controls.commandUnitMode.value);
    }

    this.state.background.mode = this.controls.backgroundMode.value || 'solid';
    this.state.background.color = this.controls.backgroundColor.value || '#ffffff';
    this.state.background.opacity = clamp(parseNumber(this.controls.backgroundOpacity.value, this.state.background.opacity), 0, 1);
    this.state.backgroundNoise.enabled = !!this.controls.backgroundNoiseEnabled.checked;
    this.state.backgroundNoise.grainSizeMm = clamp(
      this.uiToMm(parseNumber(this.controls.backgroundNoiseSize.value, this.mmToUi(this.state.backgroundNoise.grainSizeMm))),
      0.2,
      8
    );
    this.state.backgroundNoise.contrast = clamp(parseNumber(this.controls.backgroundNoiseContrast.value, this.state.backgroundNoise.contrast), 0, 1);
    this.state.backgroundNoise.colorA = this.controls.backgroundNoiseColorA.value || DEFAULT_NOISE_COLOR_A;
    this.state.backgroundNoise.colorB = this.controls.backgroundNoiseColorB.value || DEFAULT_NOISE_COLOR_B;
    this.noiseTextureCache = null;

    var stepAxis = this.controls.stepList.querySelectorAll('[data-step-axis]');
    var stepDir = this.controls.stepList.querySelectorAll('[data-step-dir]');
    this.state.steps = [];
    for (var i = 0; i < Math.max(0, this.state.tagCount - 1); i += 1) {
      var dirValue = stepDir[i] ? parseInt(stepDir[i].value, 10) : 1;
      if (dirValue !== -1) {
        dirValue = 1;
      }
      this.state.steps.push({
        axis: stepAxis[i] ? stepAxis[i].value : 'horizontal',
        dir: dirValue
      });
    }

    this.ensureTagCollection(previousCount !== this.state.tagCount);
    this.ensureTagSizes();
    if (sourceEventTarget === this.controls.tagSize) {
      for (var sizeIndex = 0; sizeIndex < this.state.tagCount; sizeIndex += 1) {
        this.state.tagSizesMm[sizeIndex] = this.state.tagSizeMm;
      }
    }

    var idInputs = this.controls.idList.querySelectorAll('[data-tag-id]');
    var idBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
    var minTagId = idBounds.min;
    var maxTagId = idBounds.max;
    for (var j = 0; j < this.state.tagCount; j += 1) {
      if (!idInputs[j]) {
        continue;
      }
      var idValue = clamp(Math.round(parseNumber(idInputs[j].value, this.state.tags[j].id)), minTagId, maxTagId);
      this.state.tags[j].id = idValue;
    }
    this.resolveUniqueViableTagIds();

    if (this.state.layoutMode === 'auto') {
      this.ensureTagCollection(true);
    }

    this.refreshPresetDependentOptions(false);
  };


  ScaleBarBuilder.prototype.updateToolButtonStates = function () {
    if (this.controls.toolSelect) {
      this.controls.toolSelect.classList.toggle('active', this.state.activeTool === 'select');
    }
    if (this.controls.toggleInfoOverlay) {
      var infoDimmed = this.isInfoOverlayDimmed();
      this.controls.toggleInfoOverlay.textContent = infoDimmed ? 'Show Info' : 'Hide Info';
      this.controls.toggleInfoOverlay.classList.toggle('active', !infoDimmed);
    }
    if (this.controls.toggleBackgroundNoise) {
      var noiseEnabled = !!(this.state.backgroundNoise && this.state.backgroundNoise.enabled);
      this.controls.toggleBackgroundNoise.textContent = noiseEnabled ? 'Noise On' : 'Noise Off';
      this.controls.toggleBackgroundNoise.classList.toggle('active', noiseEnabled);
    }
    if (this.controls.noiseSettings) {
      var noiseSelected = !!(this.state.selectedEntity && this.state.selectedEntity.type === 'noise');
      this.controls.noiseSettings.classList.toggle('active', noiseSelected);
    }
    if (this.controls.copyEntity) {
      this.controls.copyEntity.disabled = !this.canCopySelectedEntity();
    }
    if (this.controls.pasteEntity) {
      this.controls.pasteEntity.disabled = !(this.entityClipboard && this.entityClipboard.type && this.entityClipboard.data);
    }
    if (this.controls.duplicateEntity) {
      this.controls.duplicateEntity.disabled = !this.canCopySelectedEntity();
    }
    if (this.controls.setHome) {
      this.controls.setHome.classList.toggle('active', !!this.state.homeSetMode);
      this.controls.setHome.textContent = this.state.homeSetMode ? 'Click Canvas...' : 'Set Home';
    }
    if (this.controls.realityScanOutputMode) {
      this.state.realityScanOutputMode = this.sanitizeRealityScanOutputMode(this.state.realityScanOutputMode);
      var isDistance = this.state.realityScanOutputMode === 'distance';
      this.controls.realityScanOutputMode.textContent = isDistance ? 'Distance Mode' : 'Ground Control';
      this.controls.realityScanOutputMode.classList.toggle('active', isDistance);
      this.controls.realityScanOutputMode.disabled = this.state.softwarePreset !== 'realitycapture';
    }
    if (this.controls.downloadTagCsv) {
      this.controls.downloadTagCsv.disabled = false;
    }
    if (this.controls.downloadMetashapePy) {
      this.controls.downloadMetashapePy.disabled = this.state.softwarePreset !== 'metashape';
    }
    if (this.controls.zoomLevel) {
      this.controls.zoomLevel.textContent = Math.round(this.state.viewZoom * 100) + '%';
    }
    if (this.controls.zoomReset) {
      this.controls.zoomReset.textContent = Math.round(this.state.viewZoom * 100) + '%';
    }
    this.updateHistoryButtons();
  };


  ScaleBarBuilder.prototype.captureSelectionShelfFocusState = function () {
    if (!this.controls.selectionShelf) {
      return null;
    }
    var active = document.activeElement;
    if (!active || !this.controls.selectionShelf.contains(active) || !active.dataset || !active.dataset.shelfField) {
      return null;
    }
    var field = active.dataset.shelfField;
    var selector = '[data-shelf-field="' + field + '"]';
    var matches = this.controls.selectionShelf.querySelectorAll(selector);
    var index = 0;
    for (var i = 0; i < matches.length; i += 1) {
      if (matches[i] === active) {
        index = i;
        break;
      }
    }
    var caretStart = null;
    var caretEnd = null;
    try {
      if (typeof active.selectionStart === 'number' && typeof active.selectionEnd === 'number') {
        caretStart = active.selectionStart;
        caretEnd = active.selectionEnd;
      }
    } catch (error) {
      caretStart = null;
      caretEnd = null;
    }
    return {
      field: field,
      index: index,
      tagName: active.tagName ? active.tagName.toLowerCase() : '',
      value: typeof active.value === 'string' ? active.value : null,
      caretStart: caretStart,
      caretEnd: caretEnd
    };
  };


  ScaleBarBuilder.prototype.isLiveColorInputActiveIn = function (container) {
    if (!container) {
      return false;
    }
    var active = document.activeElement;
    if (!active || !container.contains(active)) {
      return false;
    }
    if (!active.tagName || active.tagName.toLowerCase() !== 'input') {
      return false;
    }
    return String(active.type || '').toLowerCase() === 'color';
  };


  ScaleBarBuilder.prototype.restoreSelectionShelfFocusState = function (focusState) {
    if (!focusState || !this.controls.selectionShelf) {
      return;
    }
    var selector = '[data-shelf-field="' + focusState.field + '"]';
    var matches = this.controls.selectionShelf.querySelectorAll(selector);
    if (!matches || matches.length === 0) {
      return;
    }
    var target = matches[Math.min(focusState.index, matches.length - 1)];
    if (!target || (focusState.tagName && target.tagName && target.tagName.toLowerCase() !== focusState.tagName)) {
      return;
    }
    if (focusState.value !== null && typeof target.value === 'string') {
      target.value = focusState.value;
    }
    target.focus({ preventScroll: true });
    if (focusState.caretStart !== null && focusState.caretEnd !== null) {
      try {
        target.setSelectionRange(focusState.caretStart, focusState.caretEnd);
      } catch (error) {
        // Some input types don't support setSelectionRange.
      }
    }
  };

})();
